(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Discover', Discover);

    Discover.$inject = ['$resource'];

    function Discover($resource) {
        var service = $resource('/api/profiles/suggestions', {}, {
            'getList': {
                method: 'GET',
                isArray: true,
                url: '/api/profiles/suggestions?excludes=:excludes'
            }
        });
        return service;
    }

})();
